import React, {useEffect, useState} from 'react';
import {PcCreatingPlan} from './pc/PcCreatingPlan'; // 注意这里是默认导入
import {MobileCreatingPlan} from './mobile/MobileCreatingPlan'; // 注意这里是默认导入

function CreatingPlan({isMobile, clicked, clickNext, isCurPage, ...props}) { // 接收 isMobile props

    const [percentageList, setPercentageList] = useState([
        {start: false},
        {start: false},
        {start: false}
    ]);
    const nextPercentage = () => {
        let check = false;
        const newPercentage = percentageList.map((item) => {
            if (!item.start && !check) {
                check = true;
                return {
                    start: true
                }
            }
            return item;
        });
        if (!check) {
            clickNext();
            return;
        }
        setPercentageList(newPercentage);
    }

    useEffect(() => {
        if (!isCurPage) {
            setPercentageList([
                {start: false},
                {start: false},
                {start: false}
            ]);
            return ;
        }
        nextPercentage();

    }, [isCurPage]);

    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clicked,
        percentageList,
        nextPercentage,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };


    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileCreatingPlan {...commonProps} />;
    } else {
        return <PcCreatingPlan {...commonProps} />;
    }
}

export default CreatingPlan;